import Footer from "../../components/Footer/Footer";
import rinData from "../../temp/rin-page.json";
import "./RinPage.css";

function RinPage() {
  return (
    <div className="rin-page">
      <div className="rin-page__content">
        <div className="rin-page__rin-type-container">
          <h3>ऋणका प्रकारहर</h3>
          {rinData.rinType.map((el) => {
            return (
              <div key={el.id} className="rin-page__rin-type">
                <h4>{el.name}</h4>: &nbsp; <p>{el.value}</p>
              </div>
            );
          })}
        </div>
      </div>

      <h3>ऋण उप-समिति</h3>
      <div className="rin-page__content">
        {rinData?.rinSamiti?.map((el) => {
          return (
            <div className="rin-page__member" id={el.id} key={el.id}>
              <img className="rin-page__image" src={el.image} alt="kj" />
              <h3 className="rin-page__heading">{el.post}</h3>:
              <p className="rin-page__para"> {el.name}</p>
            </div>
          );
        })}
      </div>

      <Footer />
    </div>
  );
}

export default RinPage;
